import React from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import type { FieldValidation } from '@rjsf/utils';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

export const ValidateNestleOwners = ({
  onChange,
  rawErrors,
  required,
  formData,
  idSchema,
  schema: { title, description },
}: FieldExtensionComponentProps<string>) => {
  return (
    <FormControl
      margin="normal"
      required={required}
      error={rawErrors?.length > 0 && !formData}
    >
      <InputLabel htmlFor="validateName">{title}</InputLabel>
      <Input
        id={`validateOwner-${idSchema?.$id}`}
        aria-describedby="entityName"
        onChange={e => onChange(e.target?.value)}
      />
      <FormHelperText id="entityName">{description}</FormHelperText>
    </FormControl>
  );
};

export const ValidateNestleOwnersValidation = (
  value: string,
  validation: FieldValidation,
) => {
  const nestle_domain = /^[\w-\.]+@([\w-]+\.)?nestle.com$/g.test(value);

  if (nestle_domain === false) {
    validation.addError(`Must have a nestle.com email.`);
  }
};
